// Sync Engine Pulse: seven vertical gold cylinders that breathe in and
// out on staggered easings, so the header of the Sync Engine page reads
// as a living engine heart rather than a static column chart.
//
// Pure CSS animation. No requestAnimationFrame, no canvas. GPU friendly
// (transform + opacity only) so it stays smooth on mid-tier phones. The
// container is a tidy 220 x 96 px hero decoration that sits next to the
// H1.

import "./SyncEnginePulse.css";

const BARS = [
  { delay: "0s",    height: 78 },
  { delay: "0.18s", height: 92 },
  { delay: "0.35s", height: 64 },
  { delay: "0.55s", height: 100 },
  { delay: "0.75s", height: 72 },
  { delay: "0.9s",  height: 86 },
  { delay: "1.1s",  height: 58 },
];

export default function SyncEnginePulse({ testId = "sync-engine-pulse" }) {
  return (
    <div
      className="sync-engine-pulse"
      data-testid={testId}
      aria-hidden
    >
      <div className="sync-engine-pulse-glow" />
      <div className="sync-engine-pulse-bars">
        {BARS.map((b, i) => (
          <span
            key={i}
            className="sync-engine-pulse-bar"
            style={{
              animationDelay: b.delay,
              // Target peak height, in percent of container. The CSS keyframe
              // pumps between 22 percent and this peak so every cylinder rides
              // its own amplitude.
              "--peak": `${b.height}%`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
